module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-11-579da95b5fd6c4ad479f64d1bbfd7133.jpg";